<template>
    <app-tabela
        :itens="outrasEmpresas"
        :campos="campos"
        :itensPorPagina="itensPorPagina"
        :mostrarFiltro="false"
        :bordered="false"
        :small="false">
        <template slot="cnpj" slot-scope="outrasEmpresas">
            ({{ outrasEmpresas.cnpj }}) 
        </template>
        <template slot="botoes">
            <slot name="botoes"></slot>
        </template>
        <template slot="acoes" slot-scope="data">
            <btn-excluir-outra-empresa
                v-if="operacao != 'D'"
                :outraEmpresa="data"
                @excluirOutraEmpresa="$emit('excluirOutraEmpresa', data)"
            ></btn-excluir-outra-empresa>
            <slot name="acoes" v-bind="data"></slot>
        </template>
    </app-tabela>
</template>

<script>
import BtnExcluirOutraEmpresa from './BtnExcluirOutraEmpresa'

export default {
    components: {
        BtnExcluirOutraEmpresa
    },

    props: {
        outrasEmpresas: {
            type: Array,
            default: () => []
        },

        temAcoes: {
            type: Boolean,
            default: () => false
        },

        operacao: {
            type: String,
            default: () => 'D'
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'cnpj',
                    label: 'CNPJ',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        ajustaTabela() {
            if (!this.temAcoes) {
                this.campos.pop()
            } else {
                this.campos.push({
                    key: 'acoes',
                    label: 'Ações'
                })
            }
        }
    },

    watch: {
        temAcoes() {
            this.ajustaTabela()
        }
    },

    created() {
        this.ajustaTabela()
    }
}
</script>
